var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPivotTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  clipRule: "evenodd",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 7.25v5.25h1.947V7.25H3.5zm0-1.5h1.947V3.5H3.5v2.25zm3.447 1.5v5.25H12.5V7.25H6.947zm5.553-1.5H6.947V3.5H12.5v2.25zM3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPivotTable);
export default ForwardRef;